import { getValidAuthToken, decodeToken } from '@/utils/auth';

/**
 * Hook to check if the user has specific permission scopes.
 * Returns false if token is expired, invalid, or missing.
 * @param requiredScopes - Array of permission scopes to check
 * @returns boolean indicating if user has all required scopes
 */
export function useHasScopes(requiredScopes: string[]): boolean {
  // Get valid (non-expired) token
  const token = getValidAuthToken();

  if (!token) {
    return false;
  }

  const decoded = decodeToken(token);

  if (!decoded) {
    return false;
  }

  const userScopes = decoded.scope ?? [];
  return requiredScopes.every((scope) => userScopes.includes(scope));
}
